import { ApolloClient, InMemoryCache, from } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
// Apollo upload client may not be compatable with future versions of apollo.
// In that case we may need to look at a different way front and back end of handling file uploads.
// See https://www.apollographql.com/blog/backend/file-uploads/file-upload-best-practices/ for more details
import { createUploadLink } from 'apollo-upload-client'
import _ from 'lodash'
import { SIGN_IN_STATE } from '../constants'

const storage = window.localStorage
// When RetryLink sees that the request to HttpLink failed due to network issues,
// it will not pass along the error response but instead wait and retry the request again
// until the request succeeds (based on the current configuration).
const retry = new RetryLink({ attempts: { max: 3 } })

const getUploadLink = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname.includes('ngrok.io')) {
    // return { uri: 'http://localhost:3000/graphql' }
    return { uri: 'https://staging.littlebits.com/graphql' }
    // { uri: 'https://dev2.littlebits.com/graphql' }
  } else if (window.location.hostname === 'rc-edu.sphero.com') {
    return { uri: 'https://rc-classroom.littlebits.com/graphql' }
  } else if (window.location.hostname === 'edu.sphero.com') {
    return { uri: 'https://api.littlebits.com/graphql' }
  } else return { uri: 'https://staging.littlebits.com/graphql' }
}

const httpLink = createUploadLink(getUploadLink())

// Link for authenticating users
const authLink = setContext((_, { headers }) => {
  const token = storage.getItem('auth-token')

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      if (_.includes(message, 'User Authentication required') || _.includes(message, 'JWT::ExpiredSignature Exception: Signature has expired')) {
        window.location.href = `/${SIGN_IN_STATE.EXPIRED}`
      } else if (_.includes(message, 'Program is not accessible')) {
        window.location.href = '/404'
      } else {
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      }
    })
    if (networkError) {
      if (_.includes(networkError, 'User not recognized in this application')) {
        window.location.href = `/${SIGN_IN_STATE.EXPIRED}`
      } else console.error(`Network error]: ${networkError}`)
    }
  }
})

const link = authLink.concat(httpLink)

const cache = new InMemoryCache({
  addTypename: false,
  dataIdFromObject: object => object.slug || null
})

const client = new ApolloClient({
  addTypename: false,
  cache,
  link: from([errorLink, retry, link])
})

export default client
